var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "history-map-legend" },
    _vm._l(_vm.legendItems, function (item, key) {
      return _vm.selectedItems.includes(key)
        ? _c("div", { staticClass: "history-map-legend-item" }, [
            _c("img", { attrs: { alt: "", src: item[1] } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(item[0]))]),
          ])
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }